import React, { useContext, useEffect, useState } from 'react'
import { Form, Input, Label } from 'semantic-ui-react';
import InputSelectText from '../InputSelect/InputSelectText';
import GlobalContext from '../../../contexts/GlobalContext';
import Utility from './../../../Utility';
import './InputText.css';

/**
 * Components InputText
 * Retourne les champs de type text (ou password) des formulaire
 * @param string props.value (require)
 * @param string props.name (require)
 * @param string props. (require)
 * @param string props.typePattern (require)
 * @param bool props.required
 * @param string props.placeholder
 * @param object props.icon
 * @param string props.iconPosition
 * @param bool props.disabled
 * @param string props.labelError
 * @param bool props.error
 * @param Object props.select
 * @param string props.type
 * @param function props.handleReload
 * @param function props.handleChange
 */
const InputText = (props) => {
  const [globalContext] = useContext(GlobalContext);
  let { required, placeholder, name, icon, iconPosition, disabled, label, labelError } = props;
  const [valueState, setValueState] = useState(props.value);
  const [errorState, setErrorState] = useState(false);
  const [errorSelectState, setErrorSelectState] = useState(false);
  const [typeInputState, setTypeInputState] = useState('text');

  let select = {
    name: null,
    value: null,
    data: null,
    error: false,
  }
  if (undefined !== props.select) {
    select = {
      name: props.select.name,
      value: props.select.value,
      data: props.select.data,
      error: errorSelectState,
    };
  }

  useEffect(() => {
    if (props.type !== undefined) {
      setTypeInputState(props.type);
    }
    if (props.value !== undefined) {
      setValueState(props.value);
    }
    if (props.error !== undefined) {
      setErrorState(props.error);
    }
    if (props.select !== undefined) {
      if (props.select.error !== undefined) {
        setErrorSelectState(props.select.error);
      }
    }
  }, [props]);

  /**
   * Gestion de l'evenement change (select)
   */
  const handleChangeSelect = (event) => {

    let test = Utility.checkValue(event.target.name.substr(6), event.target.value, props.typePattern);
    if (props.select !== undefined && props.select !== null) {
      if (props.select.handleChangeSelect !== undefined && props.select.handleChangeSelect !== null) {
        props.select.handleChangeSelect(test.target, test.value);
      }
    }

    setErrorSelectState(test.error);
  }

  /**
   * Gestion de l'evenement change (text)
   */
  const handleChange = (event) => {
    let test = Utility.checkValue(event.target.name.substr(6), event.target.value, props.typePattern);
    
    if (props.handleReload) {
      props.handleReload(test);
    }
    if (props.handleChange) {
      props.handleChange(name, test.value);
    }

    if (props.required) {
      setErrorState(test.error);
    }
    setValueState(test.value);
  }

  /**
   * Rendu du select include dans l'input
   * @returns Object jsx
   */
  const getSelect = () => {
    if (select.name) { select.name = 'input_' + select.name }
    return (
      <InputSelectText
        name={select.name}
        value={select.value}
        data={select.data}
        required={required}
        handleChange={handleChangeSelect}
        compact
        error={errorSelectState}
        disabled={disabled}
      />
    )
  }

  /**
   * Rendu du label error
   * @returns Object jsx
   */
  const getLabelError = () => {
    if (errorState && labelError) {
      return (
        <Label basic color="red" pointing>
          {(labelError === true) ? globalContext.translations.enterValue : labelError}
        </Label>
      );
    } else {
      return null
    }
  }

  if (!props.placeholder) placeholder = label;

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <Form.Field required={required} error={errorState} className={(select.name) ? 'inputWithSelect' : null}>
      <label>{label}</label>
      {(select.name) ? getSelect() : null}
      <Input placeholder={placeholder} name={'input_' + name} defaultValue={valueState} onChange={handleChange} icon={icon} iconPosition={iconPosition} disabled={disabled} type={typeInputState} />
      {getLabelError()}
    </Form.Field>
  )
}

export default InputText;
